import React, { FC, useRef } from 'react';
import { Modal, Button, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

const { Title } = Typography;

type Props = {
  open: boolean;
  onClose: () => void;
}

const MortgageMakerTutorialModal:FC<Props> = ({ open, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isFirstLogin = location.state?.isFirstLogin;
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const handleWatchNow = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  const handleSkip = () => {
    if (isFirstLogin) {
      navigate(location.pathname, { replace: true, state: { ...location.state, isFirstLogin : false } });
    }

    onClose()
  };

  return (
    <Modal
      open={open}
      footer={null}
      centered
      width={800}
      style={{ maxWidth: '90%' }}
      maskClosable={false}
      onCancel={handleSkip}
    >
      <div style={{ textAlign: 'center' }}>
        <Title
          level={2}
          style={{ color: "#000000d9", paddingBottom: '0.5rem' }}
        >
          Watch This 8-Minute Walkthrough Before You Dive In
        </Title>
        <Title
          level={4}
          style={{ lineHeight: '1.6' }}
        >
          This quick tutorial video shows you how to build your first presentation and start using
          Mortgage Maker with confidence
        </Title>
        <Title
          level={4}
          style={{ color: "#00000073", paddingTop: '0.5rem' }}
        >
          Most users who watch this video get their first conversion 3x faster
        </Title>

        <div style={{ marginTop: '2rem' }}>
          <video
            ref={videoRef}
            width="100%"
            controls
            autoPlay
            muted
            style={{ borderRadius: '10px' }}
          >
            <source src="/tutorials/mortgage-maker-tutorial.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          <Button type="primary" size="large" onClick={handleWatchNow}>
            ▶️ Watch Now
          </Button>
          <Button type="default" className="btn-default-dark-blue" size="large" onClick={handleSkip}>
            Skip and Explore
          </Button>
        </div>

        <Title
          level={4}
          style={{ color: "#00000073", paddingTop: '1.5rem' }}
        >
          You can access this tutorial video anytime by clicking the <strong>Tutorial</strong> button
        </Title>
      </div>
    </Modal>
  );
};

export default MortgageMakerTutorialModal;
